import { useSelector } from "react-redux";
// @ts-expect-error: ignoring as it is existing js file
import { applicationSelector } from "@/store/slices/applicationFormSlice";
import type {
  ApplicationFormSlice,
  ApplicationState,
} from "@/store/slices/types/applicationFormSlice";
import { applicationPurpose } from "@/constants";
import { useFeatureFlags } from "@/utils/featureFlags";

const useDemoCommercialApplication = () => {
  const { isDemoCommercialApplicationEnabled } = useFeatureFlags();
  const application = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);
  const isDemoCommercialApplication = application?.purpose === applicationPurpose.loanPurposeDemo && isDemoCommercialApplicationEnabled();

  return {
    isDemoCommercialApplication,
  };
};

export { useDemoCommercialApplication };
